export const ARIA_CURRENT = 'page';
export const OFFCANVAS_LINK_PANEL_A11Y_ID = 'offcanvas-panel-title-a11y-id';
